export const SIGNING_METHOD = Symbol() as InjectionKey<Ref<SigningMethod>>

export const SR_INVITATION = Symbol() as InjectionKey<boolean>

export const SR_QUALITY = Symbol() as InjectionKey<Ref<Lowercase<SignatureQuality>>>

export const SR_LEGISLATION = Symbol() as InjectionKey<Ref<Lowercase<Legislation>>>

export const INVITING_BUSINESS_ID = Symbol() as InjectionKey<Ref<string>>
